import React, { useState, useEffect } from 'react';
import { getContactos, crearContacto, actualizarContacto, eliminarContacto } from '../lib/db';

export default function CRM({ empresaId }) {
  const [contactos, setContactos] = useState([]);
  const [filtroEtiqueta, setFiltroEtiqueta] = useState('todos');
  const [filtroTexto, setFiltroTexto] = useState('');
  const [showNuevo, setShowNuevo] = useState(false);
  const [editando, setEditando] = useState(null);
  const [showConfirm, setShowConfirm] = useState(null);
  const [nuevo, setNuevo] = useState({ nombre: '', empresa_contacto: '', telefono: '', email: '', cargo: '', notas: '', etiqueta: 'prospecto' });
  const [editData, setEditData] = useState({});

  useEffect(() => {
    if (!empresaId) return;
    getContactos(empresaId).then(({ data }) => { if (data) setContactos(data); });
  }, [empresaId]);

  const agregar = async () => {
    if (!nuevo.nombre) return;
    const { data, error } = await crearContacto({ empresa_id: empresaId, ...nuevo });
    console.log('crearContacto:', data, error);
    if (data) {
      setContactos([data, ...contactos]);
    } else {
      const { data: recargados } = await getContactos(empresaId);
      if (recargados) setContactos(recargados);
    }
    setNuevo({ nombre: '', empresa_contacto: '', telefono: '', email: '', cargo: '', notas: '', etiqueta: 'prospecto' });
    setShowNuevo(false);
  };

  const guardarEdicion = async (id) => {
    await actualizarContacto(id, editData);
    setContactos(contactos.map(c => c.id === id ? { ...c, ...editData } : c));
    setEditando(null); setEditData({});
  };

  const cambiarEtiqueta = async (id, etiqueta) => {
    await actualizarContacto(id, { etiqueta });
    setContactos(contactos.map(c => c.id === id ? { ...c, etiqueta } : c));
  };

  const eliminar = async (id) => {
    await eliminarContacto(id);
    setContactos(contactos.filter(c => c.id !== id));
    setShowConfirm(null);
  };

  const etiquetaColor = { prospecto: '#f59e0b', cliente: '#00e5a0', inactivo: '#6b7280' };
  const etiquetaLabel = { prospecto: 'Prospecto', cliente: 'Cliente', inactivo: 'Inactivo' };

  const contactosFiltrados = contactos.filter(c =>
    (filtroEtiqueta === 'todos' || c.etiqueta === filtroEtiqueta) &&
    (!filtroTexto || c.nombre?.toLowerCase().includes(filtroTexto.toLowerCase()) ||
      c.empresa_contacto?.toLowerCase().includes(filtroTexto.toLowerCase()) ||
      c.email?.toLowerCase().includes(filtroTexto.toLowerCase()) ||
      c.telefono?.includes(filtroTexto))
  );

  const total = contactos.length;
  const prospectos = contactos.filter(c => c.etiqueta === 'prospecto').length;
  const clientes = contactos.filter(c => c.etiqueta === 'cliente').length;

  const s = {
    input: { width: '100%', background: '#181c24', border: '1px solid #222730', borderRadius: '6px', padding: '10px 12px', color: '#e8eaf0', fontSize: '13px', boxSizing: 'border-box' },
    inputVerde: { width: '100%', background: '#181c24', border: '1px solid #00e5a0', borderRadius: '6px', padding: '8px 10px', color: '#e8eaf0', fontSize: '13px', boxSizing: 'border-box' },
    label: { fontSize: '11px', color: '#6b7280', display: 'block', marginBottom: '4px' },
    btnGreen: { background: '#00e5a0', color: '#000', border: 'none', borderRadius: '6px', padding: '8px 16px', fontSize: '13px', fontWeight: '700', cursor: 'pointer' },
    btnOutline: { background: 'transparent', border: '1px solid #222730', color: '#9ca3af', borderRadius: '6px', padding: '8px 16px', fontSize: '13px', cursor: 'pointer' },
    btnSm: { background: 'transparent', border: '1px solid #222730', color: '#9ca3af', borderRadius: '6px', padding: '4px 8px', fontSize: '11px', cursor: 'pointer' },
  };

  return (
    <div style={{ padding: '28px 32px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
        <div>
          <h2 style={{ fontSize: '20px', fontWeight: '700', color: '#ffffff', marginBottom: '4px' }}>CRM</h2>
          <div style={{ fontSize: '13px', color: '#6b7280' }}>Gestión de contactos y prospectos</div>
        </div>
        <button onClick={() => setShowNuevo(true)} style={s.btnGreen}>+ Nuevo contacto</button>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '16px', marginBottom: '24px' }}>
        {[
          { label: 'Total contactos', value: total, color: '#3b82f6' },
          { label: 'Prospectos', value: prospectos, color: '#f59e0b' },
          { label: 'Clientes', value: clientes, color: '#00e5a0' },
        ].map((k, i) => (
          <div key={i} style={{ background: '#111318', border: '1px solid #222730', borderRadius: '10px', padding: '20px', borderTop: `2px solid ${k.color}` }}>
            <div style={{ fontSize: '11px', textTransform: 'uppercase', letterSpacing: '2px', color: '#6b7280', marginBottom: '10px' }}>{k.label}</div>
            <div style={{ fontSize: '32px', fontWeight: '700', color: k.color, lineHeight: 1 }}>{k.value}</div>
          </div>
        ))}
      </div>

      {showNuevo && (
        <div style={{ background: '#111318', border: '1px solid #00e5a0', borderRadius: '10px', padding: '24px', marginBottom: '24px' }}>
          <div style={{ fontSize: '14px', fontWeight: '600', color: '#ffffff', marginBottom: '16px' }}>Nuevo Contacto</div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '12px', marginBottom: '12px' }}>
            <div><label style={s.label}>Nombre *</label><input value={nuevo.nombre} onChange={e => setNuevo({...nuevo, nombre: e.target.value})} placeholder="Juan García" style={s.input} /></div>
            <div><label style={s.label}>Empresa</label><input value={nuevo.empresa_contacto} onChange={e => setNuevo({...nuevo, empresa_contacto: e.target.value})} placeholder="Empresa S.A." style={s.input} /></div>
            <div><label style={s.label}>Cargo</label><input value={nuevo.cargo} onChange={e => setNuevo({...nuevo, cargo: e.target.value})} placeholder="Director de Logística" style={s.input} /></div>
            <div><label style={s.label}>Teléfono</label><input value={nuevo.telefono} onChange={e => setNuevo({...nuevo, telefono: e.target.value})} placeholder="+52 81 1234 5678" style={s.input} /></div>
            <div><label style={s.label}>Email</label><input value={nuevo.email} onChange={e => setNuevo({...nuevo, email: e.target.value})} placeholder="juan@empresa.com" style={s.input} /></div>
            <div><label style={s.label}>Etiqueta</label>
              <select value={nuevo.etiqueta} onChange={e => setNuevo({...nuevo, etiqueta: e.target.value})} style={s.input}>
                <option value="prospecto">Prospecto</option>
                <option value="cliente">Cliente</option>
                <option value="inactivo">Inactivo</option>
              </select>
            </div>
          </div>
          <div style={{ marginBottom: '12px' }}>
            <label style={s.label}>Notas</label>
            <textarea value={nuevo.notas} onChange={e => setNuevo({...nuevo, notas: e.target.value})} placeholder="Notas adicionales..." rows={2}
              style={{ ...s.input, resize: 'vertical', fontFamily: 'inherit' }} />
          </div>
          <div style={{ display: 'flex', gap: '8px' }}>
            <button onClick={agregar} style={s.btnGreen}>Guardar</button>
            <button onClick={() => setShowNuevo(false)} style={s.btnOutline}>Cancelar</button>
          </div>
        </div>
      )}

      <div style={{ display: 'flex', gap: '8px', marginBottom: '16px', flexWrap: 'wrap' }}>
        {[{ id: 'todos', label: 'Todos' }, { id: 'prospecto', label: 'Prospectos' }, { id: 'cliente', label: 'Clientes' }, { id: 'inactivo', label: 'Inactivos' }].map(f => (
          <button key={f.id} onClick={() => setFiltroEtiqueta(f.id)}
            style={{ padding: '6px 14px', borderRadius: '6px', border: `1px solid ${filtroEtiqueta === f.id ? '#00e5a0' : '#222730'}`, background: filtroEtiqueta === f.id ? 'rgba(0,229,160,0.06)' : 'transparent', color: filtroEtiqueta === f.id ? '#00e5a0' : '#6b7280', fontSize: '13px', cursor: 'pointer' }}>
            {f.label}
          </button>
        ))}
        <input value={filtroTexto} onChange={e => setFiltroTexto(e.target.value)} placeholder="Buscar por nombre, empresa, email..."
          style={{ ...s.input, maxWidth: '280px', padding: '6px 12px' }} />
      </div>

      <div style={{ background: '#111318', border: '1px solid #222730', borderRadius: '10px', overflow: 'hidden' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr>{['Nombre', 'Empresa', 'Cargo', 'Teléfono', 'Email', 'Etiqueta', 'Notas', ''].map(h => (
              <th key={h} style={{ fontSize: '10px', textTransform: 'uppercase', letterSpacing: '2px', color: '#6b7280', padding: '12px 16px', textAlign: 'left', borderBottom: '1px solid #222730', fontWeight: '600' }}>{h}</th>
            ))}</tr>
          </thead>
          <tbody>
            {contactosFiltrados.map((c, i) => (
              <tr key={c.id} style={{ background: i % 2 === 0 ? 'transparent' : '#0d1117' }}>
                {editando === c.id ? (
                  <>
                    <td style={{ padding: '8px 16px' }}><input value={editData.nombre ?? c.nombre} onChange={e => setEditData({...editData, nombre: e.target.value})} style={s.inputVerde} /></td>
                    <td style={{ padding: '8px 16px' }}><input value={editData.empresa_contacto ?? c.empresa_contacto ?? ''} onChange={e => setEditData({...editData, empresa_contacto: e.target.value})} style={s.inputVerde} /></td>
                    <td style={{ padding: '8px 16px' }}><input value={editData.cargo ?? c.cargo ?? ''} onChange={e => setEditData({...editData, cargo: e.target.value})} style={s.inputVerde} /></td>
                    <td style={{ padding: '8px 16px' }}><input value={editData.telefono ?? c.telefono ?? ''} onChange={e => setEditData({...editData, telefono: e.target.value})} style={s.inputVerde} /></td>
                    <td style={{ padding: '8px 16px' }}><input value={editData.email ?? c.email ?? ''} onChange={e => setEditData({...editData, email: e.target.value})} style={s.inputVerde} /></td>
                    <td style={{ padding: '8px 16px' }}>
                      <select value={editData.etiqueta ?? c.etiqueta} onChange={e => setEditData({...editData, etiqueta: e.target.value})} style={{ ...s.inputVerde, width: 'auto' }}>
                        <option value="prospecto">Prospecto</option>
                        <option value="cliente">Cliente</option>
                        <option value="inactivo">Inactivo</option>
                      </select>
                    </td>
                    <td style={{ padding: '8px 16px' }}><input value={editData.notas ?? c.notas ?? ''} onChange={e => setEditData({...editData, notas: e.target.value})} style={s.inputVerde} /></td>
                    <td style={{ padding: '8px 16px' }}>
                      <div style={{ display: 'flex', gap: '4px' }}>
                        <button onClick={() => guardarEdicion(c.id)} style={s.btnGreen}>💾</button>
                        <button onClick={() => { setEditando(null); setEditData({}); }} style={s.btnSm}>✕</button>
                      </div>
                    </td>
                  </>
                ) : (
                  <>
                    <td style={{ padding: '12px 16px', fontSize: '13px', color: '#e8eaf0', fontWeight: '500' }}>{c.nombre}</td>
                    <td style={{ padding: '12px 16px', fontSize: '12px', color: '#9ca3af' }}>{c.empresa_contacto || '—'}</td>
                    <td style={{ padding: '12px 16px', fontSize: '12px', color: '#9ca3af' }}>{c.cargo || '—'}</td>
                    <td style={{ padding: '12px 16px', fontSize: '12px', color: '#9ca3af' }}>{c.telefono || '—'}</td>
                    <td style={{ padding: '12px 16px', fontSize: '12px', color: '#9ca3af' }}>{c.email || '—'}</td>
                    <td style={{ padding: '12px 16px' }}>
                      <select value={c.etiqueta} onChange={e => cambiarEtiqueta(c.id, e.target.value)}
                        style={{ background: `${etiquetaColor[c.etiqueta]}18`, border: `1px solid ${etiquetaColor[c.etiqueta]}40`, color: etiquetaColor[c.etiqueta], borderRadius: '6px', padding: '3px 8px', fontSize: '11px', fontWeight: '600', cursor: 'pointer' }}>
                        <option value="prospecto">Prospecto</option>
                        <option value="cliente">Cliente</option>
                        <option value="inactivo">Inactivo</option>
                      </select>
                    </td>
                    <td style={{ padding: '12px 16px', fontSize: '11px', color: '#6b7280', maxWidth: '150px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{c.notas || '—'}</td>
                    <td style={{ padding: '12px 16px' }}>
                      <div style={{ display: 'flex', gap: '4px' }}>
                        <button onClick={() => { setEditando(c.id); setEditData({}); }} style={s.btnSm}>✏️</button>
                        {showConfirm === c.id ? (
                          <>
                            <button onClick={() => eliminar(c.id)} style={{ background: '#ef4444', color: '#fff', border: 'none', borderRadius: '6px', padding: '4px 8px', fontSize: '11px', cursor: 'pointer' }}>Confirmar</button>
                            <button onClick={() => setShowConfirm(null)} style={s.btnSm}>✕</button>
                          </>
                        ) : (
                          <button onClick={() => setShowConfirm(c.id)} style={{ background: 'transparent', border: 'none', color: '#ef4444', cursor: 'pointer', fontSize: '13px' }}>🗑️</button>
                        )}
                      </div>
                    </td>
                  </>
                )}
              </tr>
            ))}
            {contactosFiltrados.length === 0 && (
              <tr><td colSpan="8" style={{ padding: '32px', textAlign: 'center', color: '#6b7280', fontSize: '13px' }}>
                {contactos.length === 0 ? 'Sin contactos registrados. Agrega uno para empezar.' : 'Sin resultados para tu búsqueda.'}
              </td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}// miércoles, 13 de mayo de 2026, 04:49:04 CEST

